var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"font-weight-600 subtitle has-text-grey-dark is-size-4"},[_vm._v(_vm._s(_vm.pageTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }